import { useEffect, useId, useRef, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import type { User } from '../lib/api'

const ITEMS = [
  { to: '/account', label: 'Đơn mua game', icon: 'fa-key', end: true },
  { to: '/account/dat-ho', label: 'Đơn đặt hộ', icon: 'fa-cart-shopping' },
  { to: '/deposit', label: 'Nạp tiền', icon: 'fa-gem' },
  { to: '/account/khac', label: 'Thông tin tài khoản', icon: 'fa-user-gear' },
]

export function UserMenu({ user, onLogout }: { user: User; onLogout: () => void }) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const menuId = useId()
  const location = useLocation()
  const initial = (user.name.trim()[0] || '?').toUpperCase()

  useEffect(() => setOpen(false), [location.pathname])

  useEffect(() => {
    if (!open) return
    const onDoc = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) setOpen(false)
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', onDoc)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onDoc)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <div className={`umenu${open ? ' open' : ''}`} ref={ref}>
      <button
        type="button"
        className="btn-reset umenu-btn"
        aria-expanded={open}
        aria-haspopup="menu"
        aria-controls={menuId}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="umenu-avatar" aria-hidden>
          {initial}
        </span>
        <span className="umenu-name">{user.name}</span>
        <i className="fa-solid fa-chevron-down umenu-caret" aria-hidden />
      </button>
      <div className="umenu-menu" id={menuId} role="menu" hidden={!open}>
        <div className="umenu-head">
          <strong>{user.name}</strong>
          <span>{user.email}</span>
        </div>
        {ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `nav-dd-item${isActive ? ' active' : ''}`}
            role="menuitem"
          >
            <i className={`fa-solid ${item.icon}`} aria-hidden />
            {item.label}
          </NavLink>
        ))}
        {user.role === 'admin' ? (
          <NavLink
            to="/admin"
            className={({ isActive }) => `nav-dd-item${isActive ? ' active' : ''}`}
            role="menuitem"
          >
            <i className="fa-solid fa-screwdriver-wrench" aria-hidden />
            Quản trị
          </NavLink>
        ) : null}
        <div className="umenu-sep" role="separator" />
        <button type="button" className="btn-reset nav-dd-item umenu-logout" role="menuitem" onClick={onLogout}>
          <i className="fa-solid fa-right-from-bracket" aria-hidden />
          Thoát
        </button>
      </div>
    </div>
  )
}
